import bg from "./bg";
import kv from "./kv";
import member from "./member";
import opening from "./opening";
import works from "./works";

export default function top() {
  const target = document.querySelector(".is-top");

  if (!target) return;

  opening();
  kv();
  works();
  member();
  bg();
}
